import React from 'react';

const Settings = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.7773 7.2215H17.4345C17.1488 5.90722 16.0059 4.93579 14.6345 4.93579C13.2631 4.93579 12.1202 5.90722 11.8345 7.2215H3.77734V8.36436H11.8345C12.1202 9.67865 13.2631 10.6501 14.6345 10.6501C16.0059 10.6501 17.1488 9.67865 17.4345 8.36436H19.7773V7.2215ZM14.6345 9.50722C13.6631 9.50722 12.9202 8.76436 12.9202 7.79293C12.9202 6.8215 13.6631 6.07865 14.6345 6.07865C15.6059 6.07865 16.3488 6.8215 16.3488 7.79293C16.3488 8.76436 15.6059 9.50722 14.6345 9.50722Z'
        fill='black'
      />
      <path
        d='M3.77734 16.3644H6.1202C6.40592 17.6786 7.54877 18.6501 8.9202 18.6501C10.2916 18.6501 11.4345 17.6786 11.7202 16.3644H19.7773V15.2215H11.7202C11.4345 13.9072 10.2916 12.9358 8.9202 12.9358C7.54877 12.9358 6.40592 13.9072 6.1202 15.2215H3.77734V16.3644ZM8.9202 14.0786C9.89163 14.0786 10.6345 14.8215 10.6345 15.7929C10.6345 16.7644 9.89163 17.5072 8.9202 17.5072C7.94877 17.5072 7.20592 16.7644 7.20592 15.7929C7.20592 14.8215 7.94877 14.0786 8.9202 14.0786Z'
        fill='black'
      />
    </svg>
  );
};

export default Settings;
